import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";

export default function ExitIntentPopup() {
  const [show, setShow] = useState(false);

  const trigger = useCallback(() => {
    if (!sessionStorage.getItem("exitIntentDismissed")) {
      setShow(true);
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("exitIntentDismissed")) return;

    // Timer: apare dupa 12s de la page load
    const timer = setTimeout(trigger, 12000);

    // Mouse exit-intent: cand cursorul paraseste viewport-ul (doar desktop)
    const handleMouseOut = (e) => {
      if (e.clientY <= 0) trigger();
    };
    document.addEventListener("mouseout", handleMouseOut);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseout", handleMouseOut);
    };
  }, [trigger]);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem("exitIntentDismissed", "true");
  };

  if (!show) return null;

  return (
    <div
      data-testid="exit-intent-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={dismiss}
    >
      <div
        className="bg-white rounded-2xl p-8 lg:p-10 max-w-md mx-4 shadow-2xl relative animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={dismiss}
          data-testid="exit-intent-close"
          className="absolute top-4 right-4 text-[#64748B] hover:text-[#4A5568] transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <h3 className="font-['Outfit'] text-2xl font-bold text-[#1A1D20] mb-3">
          Înainte să pleci...
        </h3>
        <p className="text-[#4A5568] leading-relaxed mb-6">
          Cere un audit tehnic inițial și află ce riscuri vedem pe site-ul tău WordPress, ce poate fi optimizat și ce plan ți se potrivește.
        </p>
        <Link
          to="/contact"
          onClick={dismiss}
          data-testid="exit-intent-cta"
          className="inline-flex items-center gap-2 bg-[#0F2942] text-white font-medium px-6 py-3 rounded-xl hover:bg-[#0F2942]/90 transition-all"
        >
          Cere auditul tehnic inițial <ArrowRight className="w-4 h-4" />
        </Link>
        <p className="text-xs text-[#64748B] mt-4">
          Evaluare clară. Fără obligații.
        </p>
      </div>
    </div>
  );
}
